import { Event } from '@yandex-int/messenger.utils';
import { eventChannel } from 'redux-saga';

import { NotUndefined } from '../../types';

/**
 * Фабрика для каналов событий из @yandex-int/messenger.utils.Event;
 * @param event событие @yandex-int/messenger.utils.Event
 * @returns
 */
export function eventChannelFactory<T extends NotUndefined>(event: Event<T>) {
    return eventChannel<T>((emit) => {
        const handle = (event: T) => {
            emit(event);
        };

        event.addListener(handle);

        return () => {
            event.removeListener(handle);
        };
    });
}
